export enum AasSubmodelElements {
  AnnotatedRelationshipElement = 'AnnotatedRelationshipElement',
  BasicEventElement = 'BasicEventElement',
  Blob = 'Blob',
  Capability = 'Capability',
  DataElement = 'DataElement',
  Entity = 'Entity',
  EventElement = 'EventElement',
  File = 'File',
  MultiLanguageProperty = 'MultiLanguageProperty',
  Operation = 'Operation',
  Property = 'Property',
  Range = 'Range',
  ReferenceElement = 'ReferenceElement',
  RelationshipElement = 'RelationshipElement',
  SubmodelElement = 'SubmodelElement',
  SubmodelElementCollection = 'SubmodelElementCollection',
  SubmodelElementList = 'SubmodelElementList',
}
